// 005 FR-020: one category's products (/shop/SCHOOL_BOOKS, /shop/STATIONERY). Uniforms and unknown
// codes go back to the categories, since they can't be browsed. Phones get the pushed screen's app
// bar; desktop keeps the school header from the parent layout.
import { Redirect, useLocalSearchParams } from "expo-router";
import { View } from "react-native";

import { AppBar } from "@/shell/chrome/AppBar";
import { useChromeKind } from "@/shell/chrome/useChromeKind";
import { CATEGORY_TITLES, CategoryScreen } from "@/shop/CategoryScreen";

const BROWSABLE = ["SCHOOL_BOOKS", "STATIONERY"] as const;

export default function Category() {
  const { category } = useLocalSearchParams<{ category: string }>();
  const mobile = useChromeKind() === "mobile";
  const code = BROWSABLE.find((c) => c === category);
  if (!code) return <Redirect href="/shop" />;
  return (
    <View style={{ flex: 1 }}>
      {mobile ? (
        <AppBar title={CATEGORY_TITLES[code]} fallbackHref="/shop" />
      ) : null}
      <CategoryScreen category={code} />
    </View>
  );
}
